<template>
    <div class="special-detail">
        <div class="detail-bar">
            <!-- <img src="@/assets/special-detail-bar.png" alt=""> -->
            <div class="detail-nav"  @click="back()">
              <p><i class="el-icon-arrow-left" style="font-size: 12px;"></i>返回专题列表</p>
            </div>
        </div>
        <div class="detail-banner">     
           <div class="banner-obtain" v-if="specialDetail.topicBgImg"  :style="{'background': 'url(' + specialDetail.topicBgImg+ ')'}">
           </div>
           <div class="banner-default"  v-else>
              <p class="banner-title">{{specialDetail.topicName}}</p>
           </div>
        </div>
        <!-- 头部布局 -->
        <div class="data-header flex flex-row-justify-space-between position-relative">
          <div v-if="filters.length" class="data-header-select flex-row-align-center">
            <p class="font-bold font-size-14 flex-shrink">选择</p>
            <div class="data-header-select-wrap flex-row-align-center">
              <div v-for="(item,index) in filters" :key="index" class="flex-row-align-center data-header-select-wrap-item cursor radius-clip-5">
                <p class="font-size-12 font-color-264480">{{ item.data }}</p>
                <p v-if="item.data !== specialDetail.topicName" class="data-header-select-wrap-item-x font-size-16 font-color-264480" @click="removeFilter(index)">x</p>
              </div>
              <!-- <div>
                <p class="data-header-select-wrap-clear font-size-12 font-color-264480 cursor" @click="clearAllRequest">清空</p>
              </div> -->
            </div>
          </div>
          <div v-if="totalPage && searchType != 3" class="data-header-tool flex-row-align-center flex-row-justify-end position-absolute">
            <p class="data-header-tool-count font-size-12" style="margin-right: 20px;">显示{{ totalCount }}条中的{{ range.start }}-{{ range.end }}条</p>
            <div class="flex-row-align-center">
              <div class="data-header-tool-related flex-row-justify-space-between flex-row-align-center position-relative" style="border-radius: 5px">
                <el-select v-model="filterValue" class=" mach-width" :popper-append-to-body="false" placeholder="请选择" @change="sortChange">
                  <el-option v-for="v in filterOptions" :key="v.key" :label="v.label" :value="v.key" />
                </el-select>
                <img class="position-absolute" style="right: 0; pointer-events: none;" src="@/assets/icon-lib-foldup.png">
              </div>
              <div v-if="searchType==1" class="data-header-tool-listtool flex-row-align-center">
                <div class="cursor" @click="showListView">
                  <img v-if="gridView" src="@/assets/icon-lib-unlist.png">
                  <img v-else src="@/assets/icon-lib-list.png">
                </div>
                <div class="cursor" @click="showGridView">
                  <img v-if="!gridView" src="@/assets/icon-lib-list-thumb.png">
                  <img v-else src="@/assets/icon-lib-list-unthumb.png">
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="data-line" /> -->
        </div>
        <!-- 内容 -->
        <div class="body flex">
            <!-- 左边导航 -->
            <div class="leftBar">
              <coll-bar v-if="searchType==1" ref="collBar" :menu="menuData" @params="searchParam" @showMore="showMore" @remove="removeFilterFormCommponents" />
              <file-bar v-else-if="searchType==2" ref="fileBar" :menu="fileMenuData" @params="searchParam" @showMore="showMore" @remove="removeFilterFormCommponents" />
              <user-bar v-else-if="searchType==3" ref="userBar" :menu="userMenuData" @params="searchParam" />
            </div>
            <!-- 右侧布局 -->
            <div class="data rightData flex-1">
              
                <!-- 右侧头部 -->

              <!-- 右侧内容 -->
              <div class="data-content">
                <div v-if="searchType==3">
                  <users :userdata="userData" @searchUser="searchUser" v-loading="loading"/>
                </div>
                <div v-else-if="searchType==2">
                  <files ref="file" :datas="resourceData" @params="searchParam" v-loading="loading"/>
                </div>
                <div v-else-if="searchType==1">
                  <colls :grid="!gridView" :colldata="collData" @params="searchParam" v-loading="loading"/>
                </div>
              </div>
              <div v-if="totalPage>1" class="data-pagination mach-width flex-center">      
                <el-pagination next-text="下一页" prev-text="上一页" background hide-on-single-page :current-page.sync="reqParams.current" :page-size="24" layout="total, prev, pager, next" :total="totalCount" @current-change="handleCurrentChange" />      
              </div>
            </div>
          </div>
        <selectionDate ref="selectionDate" @select="searchParam" />
        <select-topic ref="topic" @select="searchParam" />
        <select-region ref="region" @select="searchParam" />
        <select-pubdate ref="pubdate" @select="searchParam" />
        <select-person ref="person" @select="searchParam" />
        <select-pubman ref="pubman" @select="searchParam" />
        <select-create-date ref="createDate" @select="searchParam" />
    </div>
</template>
<script>
    import {
        gettTopicDetail
    } from '@/api/special'
    import searchbar from '@/components/Searchbar.vue'
    import users from './commponents/users.vue'
    import files from './commponents/files.vue'
    import colls from './commponents/colls.vue'
    import collBar from './commponents/collBar.vue'
    import fileBar from './commponents/fileBar.vue'
    import userBar from './commponents/userBar.vue'
    import searchmodel from '@/models/search.js'
    import collapi from '@/api/collections.js'
    import {
        replaceUrl
    } from '@/utils/utils.js'

    import selectPubman from './commponents/selectPubMan.vue'
    import selectionDate from './commponents/selectDate.vue'
    import selectTopic from './commponents/selectTopic.vue'
    import selectRegion from './commponents/selectRegion.vue'
    import selectPubdate from './commponents/selectPubDate.vue'
    import selectPerson from './commponents/selectPerson.vue'
    import selectCreateDate from './commponents/selectCreateDate.vue'
    var sortExp = function(key, isAsc) {
        return function(x, y) {
            if (isNaN(key)) {
            if (x[key] > y[key]) {
                return 1 * (isAsc ? 1 : -1)
            } else if (x[key] < y[key]) {
                return -1 * (isAsc ? 1 : -1)
            } else {
                return 0
            }
            } else {
            return (x[key] - y[key]) * (isAsc ? 1 : -1)
            }
        }
    }

export default {
  name: 'Collection',
  components: {
    searchbar,
    users,
    files,
    collBar,
    userBar,
    fileBar,
    colls,
    selectionDate,
    selectTopic,
    selectRegion,
    selectPubdate,
    selectPerson,
    selectPubman,
    selectCreateDate
  },
  data() {
    return {
      loading: false,
  
    specialDetail:{},

    options:{},
      requestDataFinish: false,
      reqParams: {},
      searchType: 1,
      gridView: true,
      totalPage: 0,
      totalCount: 0,
      menuData: null,
      collData: null,
      fileMenuData: null,
      userMenuData: [],
      userData: null,
      resourceData: null,
      filters: [],
      showMoreType: '',
      range: {
        start: 0,
        end: 0
      },

      filterOptions: [{
        label: '最新发布',
        key: 4
      }, {
        label: '最早发布',
        key: 5
      }, {
        label: '纪事日期（最近）',
        key: 8
      }, {
        label: '纪事日期（最早）',
        key: 9
      }, {
        label: '浏览量',
        key: 10
      }, {
        label: '收藏量',
        key: 11
      }],
      filterValue: 4,
      searchBarType: 1
    }
  },
  mounted() {

   
    
    this.gettTopicDetail()
    replaceUrl()
    this.searchType = searchmodel.type
    if (searchmodel.viewData) {
      if (!searchmodel.viewData.display) {
        this.reqParams = {
          search: searchmodel.keyword,
          current: 1,
          size: 24,
          sortType: this.filterValue
        }
        this.research()
        console.log('搜索关键词进入')
      } else {
        this.clearFilter()
        this.searchParam(searchmodel.viewData)
      }
      searchmodel.viewData = null
    } else {
      console.log('正常进入搜索页 ')
      if (!this.menuData) {
        this.reqParams = {
          search: searchmodel.keyword,
          current: 1,
          size: 24,
          sortType: this.filterValue
        }
        this.toSearch()
      }
    }
    this.$store.dispatch('navigation/setNavigatorIndex', 1)
    document.body.scrollTop = document.documentElement.scrollTop = 0
  },
  methods: {
    back(){
      this.$router.push({ 
                    name: "Special",  
                });
    },
    async gettTopicDetail() {
        this.options.id  = this.$route.query.id
        const res = await gettTopicDetail(this.options)
        console.log('res', res)
        this.loading = false
        this.totalSize = res.data.total
        this.specialDetail = res.data
        this.searchParam({
        params: {
          //commitBy: res.data.id
          commitBy: res.data.commitBy
        },
        display: res.data.topicName,
        type: 'commitBy'
      })
    },
    sortChange(v) {
      this.reqParams.sortType = v
      this.reqParams.current = 1
      this.range.start = 0
      this.range.end = 0
     
      this.request()
    },
    request() {
      if (this.searchType === 1) {
        const that = this
        that.loading = true
        this.reqParams.tenantId = this.$store.getters.tenantId
        // this.reqParams.tenantId = this.$store.getters.tenantId
        if(this.$route.query.id){
            this.reqParams.specialSubject = this.$route.query.id
          }
          console.log('reqParamsreqParams',this.reqParams)
          
        collapi.searchColl(this.reqParams).then(r => {
      
          
          r.data.records.forEach(element => {
            element.collectionName = element.collectionName + (element.subtitle ? ('-' + element.subtitle) : '') + (element.chapter ? ('-' + element.chapter) : '')
            if (that.reqParams.search) {
              const replaceString = `<span style=\"color:red;\">${that.reqParams.search}</span>`

              var reg = new RegExp(that.reqParams.search, 'g')
              element.collectionName = element.collectionName.replace(reg, replaceString)
              element.description = element.description.replace(reg, replaceString)
            }
            element.listCategory.sort(sortExp('cateLevel', true))
          })
          that.collData = r.data
          that.loading = false
          that.totalCount = r.data.total
          that.range.start = (r.data.current - 1) * 24 + 1
          that.range.end = r.data.records.length + (r.data.current - 1) * 24
          that.totalPage = r.data.pages
          that.$refs.collBar.resetCollSelectStatus(that.reqParams)
        }).catch(err => {
          console.error(err)
          that.loading = false
        })
      } else if (this.searchType === 3) {
        const that = this
        that.loading = true
        // this.$refs.userBar.resetSelectStatus(this.reqParams)
        this.reqParams.tenantId = this.$store.getters.tenantId 
        collapi.searchUser(this.reqParams).then(r => {
          r.data.records.forEach(element => {
            element['htmlName'] = element.realName
            if (that.reqParams.search) {
              const replaceString = `<span style=\"color:red;\">${that.reqParams.search}</span>`

              var reg = new RegExp(that.reqParams.search, 'g')
              element.htmlName = element.htmlName.replace(reg, replaceString)

              console.log(element)
            }
          })
          console.log(r.data)
          that.userData = r.data
          that.loading = false
          that.totalCount = r.data.total
          that.range.start = (r.data.current - 1) * 24 + 1
          that.range.end = r.data.records.length + (r.data.current - 1) * 24
          that.totalPage = r.data.pages
        })
      } else if (this.searchType === 2) {
        const that = this
        that.loading = true
        this.reqParams.tenantId = this.$store.getters.tenantId
        collapi.searchResource(this.reqParams).then(r => {
          r.data.records.forEach(element => {
            if (that.reqParams.search) {
              const replaceString = `<span style=\"color:red;\">${that.reqParams.search}</span>`

              var reg = new RegExp(that.reqParams.search, 'g')
              element.resourceName = element.resourceName.replace(reg, replaceString)
              element.description = element.description.replace(reg, replaceString)
            }
          })
          that.resourceData = null
          that.resourceData = r.data
          that.loading = false
          that.totalCount = r.data.total
          that.range.start = (r.data.current - 1) * 24 + 1
          that.range.end = r.data.records.length + (r.data.current - 1) * 24
          that.totalPage = r.data.pages
          that.$refs.fileBar.resetFileSelectStatus(that.reqParams)
        })
      }
    },
    research() {
      this.clearFilter()
      this.toSearch()
    },
    toSearch(rq) {
      if (this.searchType === 1) {
        const that = this
        const menuParams = {
          searchKey: searchmodel.keyword,
          size: 5,
          current: 1
        }

        for (const key in this.reqParams) {
          if (key === 'current' || key === 'size' || key === 'search' || key === 'sortType') {
            continue
          } else {
            menuParams[key] = this.reqParams[key]
          }
        }
        menuParams.tenantId = this.$store.getters.tenantId
        if(this.$route.query.id){
          menuParams.specialSubject = this.$route.query.id
          }
        menuParams.commitBy=''
        collapi.keyMemu(menuParams).then(r => {
          that.menuData = r.data
        }).catch(error => {
          console.error(error)
        })
        if (!rq) {
          this.request()
        }
      } else if (this.searchType === 3) {
        const that = this
        const menuParams = {
          searchKey: searchmodel.keyword,
          size: 5,
          current: 1
        }

        for (const key in this.reqParams) {
          if (key === 'current' || key === 'size' || key === 'search' || key === 'sortType') {
            continue
          } else {
            menuParams[key] = this.reqParams[key]
          }
        }
        menuParams.tenantId = this.$store.getters.tenantId
        collapi.searchUserMenu(menuParams).then(r => {
          that.userMenuData = r.data
        })
        if (!rq) {
          this.request()
        }
      } else if (this.searchType === 2) {
        const that = this
        const menuParams = {
          search: searchmodel.keyword,
          size: 5,
          current: 1
        }

        for (const key in this.reqParams) {
          if (key === 'current' || key === 'size' || key === 'search' || key === 'sortType') {
            continue
          } else {
            menuParams[key] = this.reqParams[key]
          }
        }
        menuParams.tenantId = this.$store.getters.tenantId
        collapi.searchFileMenu(menuParams).then(r => {
          that.fileMenuData = r.data
        })
        if (!rq) {
          this.request()
        }
      }
    },
    clearAllRequest() {
      this.clearFilter()
      if (this.searchType === 1) {
        this.$refs.collBar.clearAllFilter()
      } else if (this.searchType === 2) {
        this.$refs.fileBar.clearAllFilter()
      }
      this.toSearch()
    },
    handleCurrentChange(val) {
      window.scrollTo(0, 0)
      this.reqParams.current = val

      this.request()
    },
    jumpPage(page) {
      if (this.searchType === 1) {
        if (this.reqParams.current === page) {
          return
        }
        this.reqParams.current = page
      } else if (this.searchType === 3) {
        if (this.reqParams.current === page) {
          return
        }
        this.reqParams.current = page
      } else if (this.searchType === 2) {
        if (this.reqParams.current === page) {
          return
        }
        this.reqParams.current = page
      }
      this.request()
    },
    showGridView() {
      this.gridView = false
    },
    showListView() {
      this.gridView = true
    },
    searchcate(v) {
      console.log(searchmodel.keyword)
      this.filterValue = 4
      this.reqParams = {
        current: 1,
        size: 24,
        search: searchmodel.keyword
      }
      this.clearFilter()
      this.searchType = v
      this.range.start = 0
      this.range.end = 0
      this.totalPage = 0
      this.totalCount = 0
      this.toSearch()
    },
    showMore(v) {
      this.showMoreType = v.type
      if (v.type === 'date') {
        this.$refs.selectionDate.show(this.reqParams)
      } else if (v.type === 'topic') {
        this.$refs.topic.show(this.reqParams, this.searchType === 2 ? 'resource' : 'collection')
      } else if (v.type === 'region') {
        this.$refs.region.show(this.reqParams)
      } else if (v.type === 'pubdate') {
        this.$refs.pubdate.show(this.reqParams, this.searchType === 2 ? 'resource' : 'collection')
      } else if (v.type === 'person') {
        this.$refs.person.show(this.reqParams, this.searchType === 2 ? 'resource' : 'collection')
      } else if (v.type === 'pubman') {
        this.$refs.pubman.show(this.reqParams, this.searchType === 2 ? 'resource' : 'collection')
      } else if (v.type === 'createDate') {
        this.$refs.createDate.show(this.reqParams)
      }
    },
    filter(v) {
      console.log(v)
    },

    // 对象数组去重
    filterArr(arr, key) {
        let map = new Map();
        return arr.filter((item) => !map.has(item[key].toString()) && map.set(item[key].toString()))
    },
    searchParam(v) {
      this.range.start = 0
      this.range.end = 0
      for (const key in v.params) {
        this.reqParams[key] = v.params[key]
      }
      this.reqParams.current = 1
      const p = this.filters.find(r => r.type === v.type)
      console.log('ppp',this.filters)
      if (!p) {
        this.filters.push({
          type: v.type,
          data: v.display
        })
      } else {
        p.data = v.display
      }
      this.filters = this.filterArr(this.filters,'data')
      this.toSearch()
    },
    searchUser(v) {
      this.clearFilter()
      this.searchType = 1
      this.$refs.searchBar.changeSearchType(1)
      this.reqParams.current = 1
      this.reqParams.search = ''
      this.$store.dispatch('search/setKeyword', '')
      this.searchParam({
        params: {
          commitBy: v.id
        },
        display: v.realName,
        type: 'commitBy'
      })
    },
    removeFilter(index) {
      const params = this.filters[index]
      if (this.searchType === 1) {
        this.$refs.collBar.removeFilter(params.type)
        if (params.type === 'releaseDates') {
          if (this.reqParams['releaseDates']) {
            delete this.reqParams['releaseDates']
          } else {
            if (this.reqParams['releaseDateStarts']) {
              delete this.reqParams['releaseDateStarts']
            }
            if (this.reqParams['releaseDateEnd']) {
              delete this.reqParams['releaseDateEnd']
            }
          }
        } else if (params.type === 'chronicleDates') {
          if (this.reqParams['chronicleDates']) {
            delete this.reqParams['chronicleDates']
          } else {
            if (this.reqParams['startChronicleDate']) {
              delete this.reqParams['startChronicleDate']
            }
            if (this.reqParams['endChronicleDate']) {
              delete this.reqParams['endChronicleDate']
            }
          }
        } else {
          delete this.reqParams[params.type]
        }
        this.reqParams.current = 1
      } else if (this.searchType === 2) {
        this.$refs.fileBar.removeFilter(params.type)
        if (params.type === 'resourceCreateTimes') {
          if (this.reqParams['resourceCreateTimes']) {
            delete this.reqParams['resourceCreateTimes']
          } else {
            if (this.reqParams['resourceCreateTimesStarts']) {
              delete this.reqParams['resourceCreateTimesStarts']
            }
            if (this.reqParams['resourceCreateTimesEnd']) {
              delete this.reqParams['resourceCreateTimesEnd']
            }
          }
        } else if (params.type === 'publishTimes') {
          if (this.reqParams['publishTimes']) {
            delete this.reqParams['publishTimes']
          } else {
            if (this.reqParams['resourceTimesStarts']) {
              delete this.reqParams['resourceTimesStarts']
            }
            if (this.reqParams['resourceTimesend']) {
              delete this.reqParams['resourceTimesend']
            }
          }
        } else {
          delete this.reqParams[params.type]
        }
        this.reqParams.current = 1
      } else {
        this.$refs.userBar.removeFilter(params.type)
        delete this.reqParams[params.type]
        this.reqParams.current = 1
      }
      this.filters.splice(index, 1)
      this.range.start = 0
      this.range.end = 0
      this.toSearch()
    },
    clearFilter() {
      const that = this
      this.filters.forEach(item => {
        if (that.searchType === 1) {
          that.$refs.collBar.removeFilter(item.type)
        } else if (that.searchType === 2) {
          that.$refs.fileBar.removeFilter(item.type)
        } else if (that.searchType === 3) {
          that.$refs.userBar.removeFilter(item.type)
        }
      })
      this.filters = []
      this.filterValue = 4
      this.reqParams = {
        current: 1,
        size: 24,
        search: searchmodel.keyword,
        sortType: this.filterValue
      }
      this.range.start = 0
      this.range.end = 0
    },
    removeFilterFormCommponents(v) {
      delete this.reqParams[v.type]
      const that = this
      this.filters.forEach((item, index) => {
        if (item.type === v.type) {
          that.filters.splice(index, 1)
        }
      })
      this.toSearch()
    }
  }
}
</script>

<style scoped>

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  color: rgb(38, 68, 128);
  font-size: 14px;
  font-weight: 600;
  background-color: rgb(243, 244, 249);
}

::v-deep .el-pager li {
  padding: 0 4px;
  font-size: 14px;
  background-color: transparent !important;
  font-weight: 500;
  color: rgb(38, 68, 128);
  /* height: 28px; */
  line-height: 28px;
  /* box-sizing: border-box; */
  text-align: center;
}

::v-deep .btn-next {
  padding: 0 4px;
  font-size: 14px;
  background-color: transparent !important;
  font-weight: 500;
  color: rgb(38, 68, 128);
  /* height: 28px; */
  line-height: 28px;
  /* box-sizing: border-box; */
  text-align: center;
}

::v-deep .btn-prev {
  padding: 0 4px;
  font-size: 14px;
  background-color: transparent !important;
  font-weight: 500;
  color: rgb(38, 68, 128);
  /* height: 28px; */
  line-height: 28px;
  /* box-sizing: border-box; */
  text-align: center;
}
</style>
<style lang="scss" scoped>
::v-deep .el-select-dropdown__item {
  color: red($color: #000000) !important;
}

::v-deep .el-input__icon {
  display: none;
}

::v-deep .el-range-separator {
  width: 12% !important;
  line-height: 28px !important;
  color: #999 !important;
}

::v-deep .el-range__close-icon {
  width: 0px !important;
}

::v-deep .el-range-input {
  width: 44% !important;
}

::v-deep .el-input__inner {
  font-size: 12px !important;
  color: #264480 !important;
  padding: 0 !important;
  border: none !important;
  height: 22px;
  line-height: initial !important;
}

::v-deep .el-input__suffix-inner {
  display: none;
}

::v-deep .el-select-dropdown__item.selected {
  color: #264480 !important;
}
::v-deep .el-loading-mask {
  z-index: 200 !important;
}
::v-deep .el-select-dropdown__item {
  font-size: 12px;
  // line-height: 24px;
}
</style>
<style src="@/styles/pc.css" scoped>
</style>
<style scoped>
.detail-bar{
        /* position: relative; */
        background-repeat: no-repeat !important;
        background-size: 100% 100%;
        height: 40px;
        background: url("../../../assets/special-detail-bar.png") no-repeat;
        /* background: url("@/assets/special-detail-bar.png") no-repeat; */
        background-position: center !important;
        /* margin-bottom: 40px; */
        
    }
    .detail-nav { 
      position: relative;
      /* position: absolute; */
      margin-top: 0px;
      width: 1240px;
      height: 40px;
      margin: 0 auto;
    }
    .detail-nav p {
      /* width: 1240px;
      margin: 0 auto; */
      position: absolute;
      top: 13px;
      left:0px;
      color: #fff;
      font-size: 12px;
      cursor: pointer;
    }
    .detail-banner .banner-obtain{
      background-repeat: no-repeat !important;
      width: 100%;
      height: 400px;
      /* height: auto !important; */
      margin-bottom: 40px;
      /* background-size: 100% 100% !important; */
      background-position: center !important;
    }
    .detail-banner .banner-default{
        /* position: relative; */
       padding-top: 153px;
        background-repeat: no-repeat !important;
        margin-bottom: 40px;
        width: 100%;
        height: 400px;
        /* vertical-align: middle; */
        /* height: 400px; */
        /* background-color: #ddd; */
        background: url("../../../assets/special-detail.jpg") no-repeat;
        /* background-size: 100% 100%; */
        background-position: center !important;
    }
    .detail-banner .banner-default .banner-title{
      /* margin: 0 auto; */
      height: 93px;
      /* height: 100%;
      line-height: 100%; */
      /* position: absolute; */
      /* top: 153px; */
      text-align: center;
      font-size: 64px;
      font-weight: bold;
      color: #FFFFFF;
    }
    .special-detail .body {
    width: 1240px;
    padding: 0px 0 20px;
    margin: 0 auto;
    }

    .special-detail .body .menu {
    width: 280px;
    }

    .special-detail .body .menu .menu-header {
    height: 40px;
    width: 100%;
    }

    .special-detail .body .menu .menu-content {
    margin-top: 20px;
    }

    .special-detail .body .menu .menu-content .menu-content-item {
    background-color: #F3F4F9;
    margin-bottom: 10px;
    /* padding-bottom: 10px; */
    }

    .special-detail .body .menu .menu-content .menu-content-item .menu-content-item-top {
    height: 60px;
    padding: 0 20px;
    }

    .special-detail .body .menu .menu-content .menu-content-item-line {
    width: 100%;
    height: 1px;
    background-color: #264480;
    opacity: 0.1;
    }

    .special-detail .body .menu .menu-content .menu-content-item-list {
    padding: 10px;
    }

    .menu-content-item-list-item-hg {
    height: 30px;
    padding: 0 10px;
    }

    .special-detail .body .menu .menu-content .menu-content-item-list-item-sel {
    background-color: rgba(38, 42, 51, 0.4);
    }

    .special-detail .body .menu .menu-content .menu-content-item-list-item-sel .menu-content-item-list-item-sel-text {
    color: #fff;
    }

    .menu-content-item-list-item-child {
    height: 30px;
    padding: 0 10px;
    }

    .menu-content-item-list-item-children {
    padding-left: 5px;
    }

    .menu-content-item-list-item-rang {
    width: 170px;
    height: 30px;
    border: 1px solid rgba(26, 59, 128, 0.2);
    }

    .menu-content-item-list-item-rang .start {
    left: 0;
    width: 60px;
    z-index: 99;
    opacity: 0;
    }

    .menu-content-item-list-item-rang .end {
    left: 0;
    width: 60px;
    z-index: 99;
    opacity: 0;
    }

    .menu-content-item-list-item-rang>div {
    padding: 0 10px;
    }

    .menu-content-item-list-item-button {
    width: 60px;
    height: 30px;
    margin-left: 10px;
    }

    .menu-content-item-more {
    height: 30px;
    padding-right: 10px;
    margin-bottom: 10px;
    }

    .data {
    margin-left: 40px;
    /* z-index: -1; */
    }

    .data-header-select {
    min-height: 40px;
    }

    .data-header{
      width: 1240px;
      height: 32px;
      margin: 0 auto;
      margin-bottom: 34px;
    }

    .data-header-tool {
      right: 0px;
    /* height: 40px; */
    }

    .data-header-select-wrap {
    margin-left: 8px;
    flex-wrap: wrap;
    }

    .data-header-select-wrap-item {
    height: 24px;
    padding: 0 6px;
    border: 1px solid rgba(26, 59, 128, 0.2);
    margin-left: 10px;
    margin-bottom: 5px;
    }

    .data-header-select-wrap-clear {
    text-decoration: underline;
    margin-left: 10px;
    }

    .data-header-select-wrap-item-x {
    margin-left: 6px;
    margin-top: -3px;
    }

    .data-header-tool-related {
    width: 150px;
    height: 24px;
    border: 1px solid rgba(26, 59, 128, 0.2);
    padding-left: 6px;
    }

    .data-header-tool-related img {
    transform: rotate(180deg);
    }

    .data-header-tool-listtool {
    margin-left: 12px;
    }

    .data-line {
    width: 100%;
    background-color: #F3F4F9;
    height: 1px;
    margin-top: 10px;
    }

    .data-pagination {
    height: 100px;
    border-top: 1px solid rgba(38, 42, 51, 0.05);
    margin-top: 30px
    }

    .cate-more-level {
    width: 10px;
    height: 10px;
    align-items: flex-end;
    overflow: hidden;
    margin-right: 8px;
    }

    .cate-sel-close {
    width: 30px;
    height: 30px;
    }

    .menu-more {
    height: 20px;
    justify-content: end;
    }

    .transform {
    transform: rotate(180deg);
    }

    .btn {
    outline: none;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    font-size: 14px;
    color: #fff;
    background-color: #264480;
    border-color: #409EFF;
    width: 82px;
    height: 30px;
    border-radius: 5px;
    text-align: center;
    line-height: 30px;
    }

    .leftBar {
    width: 280px;
    float: left;
    }

    .rightData {
    width: 920px;
    float: right
    }
</style>
